export default __webpack_public_path__ + "static/media/logo-text-orange.14c9fdc4.svg";